import React from 'react';
import PropTypes from 'prop-types';

export default class BadgeSharing extends React.Component {
  static propTypes = {
    sharing: PropTypes.object.isRequired
  }

  render() {
    return (
      <div>
        <th-social-sharing
          appId={this.props.sharing.app_id}
          content-title={this.props.sharing.content.title}
          content-description={this.props.sharing.content.description}
          public={this.props.sharing.public}
          facebookText={this.props.sharing.facebookText}
          xText={this.props.sharing.twitterText}
          threadsText={this.props.sharing.twitterText}
          blueskyText={this.props.sharing.twitterText}
          linkedin-text={"toggle"}
        />
      </div>
    );
  }
}
